import * as React from 'react';
import { permissionStore } from '@app/Stores/PermissionStore';
import { appStore } from '../AppStore';

export interface IWindowAdal extends Window {
    adal?: {
        redirectToLogin (): void;
        redirectToLogout (): void;
    };
}

export class AzureAuth extends React.Component<{}, {}> {

    static logOut () {
        appStore.clearUserData();
        const appWindow: IWindowAdal = window;
        appWindow.adal && appWindow.adal.redirectToLogout();
    }

    static login () {
        appStore.clearUserData();
        const appWindow: IWindowAdal = window;
        appWindow.adal && appWindow.adal.redirectToLogin();
    }

    static exitImpersonation = () => {
        appStore.exitImpersonation();
    };

    public static hasAccess(permissions: number | number[]) {
        const hasAdmin = permissionStore.currentUserPermissions.includes(UserPermissions.AdminToolsWrite);
        if (hasAdmin) return true;

        if (typeof permissions === 'number') {
            return permissionStore.currentUserPermissions.indexOf(permissions) !== -1;
        }

        if (Array.isArray(permissions)) {
            for (const permission of permissions) {
                if (permissionStore.currentUserPermissions.indexOf(permission) !== -1) {
                    return true;
                }
            }
        }
        return false;
    }
}

export enum UserPermissions {
    AdminToolsWrite = 1,
    AdminToolsRead = 2,
    AdminToolsSafe = 3,
    FullPermissionImpersonate = 5,
    InitiateProcess = 6,
    PassengersEdit = 7,
    ExportBookingsList = 9,
    MasterDataEdit = 10,
    MasterDataRead = 11,
    IrregularFlightsRead = 12,
    PassengersStatusChange = 13,
    PassengersRebookedChange = 14,
    UndoCase = 15,
    ImportAvantikData = 16,
    ImportLeg = 17,
    SendToAmadeus = 18,
    ReloadAvantikData = 19,
    ReadAmadeusLogs = 20,
    ReadGuidelines = 21,
    SetFlownStatus = 22,
    EditCompletedCase = 23,
    EmailTemplatesRead = 47,
    EmailTemplatesWrite = 48,
    EmailsRead = 49,
}